/** Plan/subscription feature that unlocks FreeCut Studio (beta). */
export const FREECUT_STUDIO_FEATURE = 'freecut_studio';
